export const OUTREACH_QUEUE_FILTERS = [
  { value: "all", label: "All" },
  { value: "overdue", label: "Overdue" },
  { value: "due-today", label: "Due Today" },
  { value: "direct", label: "Direct Kevin" },
  { value: "upcoming", label: "Upcoming" },
];

const hasContactRoute = (item) => !!(item?.contact_label || item?.contact_email || item?.contact_phone);

export const deriveOutreachReasons = (item) => {
  if (item?.lane === "operations") return [];
  if (!hasContactRoute(item)) return [];

  const reasons = [];

  if (item?.follow_up_status === "overdue") {
    reasons.push({ key: "overdue", label: "Overdue follow-up" });
  }

  if (item?.follow_up_status === "due-today") {
    reasons.push({ key: "due-today", label: "Due today" });
  }

  if (item?.urgency_override === "direct") {
    reasons.push({ key: "direct", label: "Direct Kevin follow-up" });
  } else if (item?.is_kevin_flagged) {
    reasons.push({ key: "direct", label: "Kevin should step in" });
  }

  if (
    item?.stakeholder_disposition_previous_state === "dad_partner" &&
    item?.stakeholder_disposition_new_state === "prospect"
  ) {
    reasons.push({ key: "returned", label: "Returned from Dad Partners" });
  }

  if (
    item?.follow_up_status === "upcoming" &&
    (item?.follow_up_date || item?.follow_up_type || item?.follow_up_type_label)
  ) {
    reasons.push({ key: "upcoming", label: "Upcoming follow-up" });
  }

  return reasons;
};

export const isOutreachQueueItem = (item) => deriveOutreachReasons(item).length > 0;

export const matchesOutreachQueueFilter = (item, filterValue) => {
  if (!filterValue || filterValue === "all") return true;
  return deriveOutreachReasons(item).some((reason) => reason.key === filterValue);
};
